import { connect, type ConnectedProps } from 'react-redux';

import { type RootState } from '~/reducers';
import mediator from '~/utilities/mediator';

import AccountInfoAdult from './AccountInfoAdult';

const mapStateToProps = ({ auth }: RootState) => ({
  patient: auth.include?.patient,
});

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector>;

const AccountInformation = ({ patient }: Props) => {
  const onBack = () => {
    mediator.publish('router:back');
  };

  return <AccountInfoAdult patient={patient} onBack={onBack} />;
};

export default connector(AccountInformation);
